import { Spin, notification } from "antd";
import requestService from "api/request";
import { validateEmail, validatePassword } from "lib/helpers/format";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { onSetUser } from "store/app";

const Login = () => {
  const [form, setForm] = useState<any>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogin = async () => {
    //const { email, password } = form;
    // if (!validateEmail(email)) {
    //   return notification.error({
    //     message: "Invalid email format",
    //     duration: 5,
    //   });
    // }
    if (!validatePassword(form?.password)) {
      return notification.error({
        message: "Password must be at least 6 characters",
        duration: 5,
      });
    }
    setLoading(true);

    try {
      const res = await requestService.post("/auth/login", {
        data: {
          ...form,
        },
      });
      if (res && res.data) {
        dispatch(onSetUser(res?.data?.data?.user));
        localStorage.setItem(
          "accessToken",
          res?.data?.data?.tokens?.accessToken
        );
        localStorage.setItem(
          "refreshToken",
          res?.data?.data?.tokens?.refreshToken
        );
        notification.success({
          message: "Login Success",
          duration: 10,
        });
        navigate("/trading");
      }
    } catch (error: any) {
      console.log(error);

      notification.error({
        message: error?.response?.data?.message || "Có lỗi xảy ra thử lại !!!",
        duration: 3,
      });
    }
    setLoading(false);
  };
  return (
    <div className="min-h-[100vh] bg-v3BgPrimary" data-v-bc61f9fc="">
      <Spin spinning={loading} fullscreen />
      <div className="main-box lay-box clearfix " data-v-bc61f9fc="">
        <div
          className="main-login-wrapper black flex items-center justify-center"
          data-v-6fa5d2d2=""
          data-v-bc61f9fc=""
        >
          <div className="main-login" data-v-6fa5d2d2="">
            <div
              className="container main-box-container main-box-container-login"
              data-v-62803376=""
              data-v-6fa5d2d2=""
            >
              <div className="login-wrap black mainReg" data-v-62803376="">
                <div className="login-qr-box" data-v-62803376="">
                  {/**/}
                  <div className="clearfix login-title-box" data-v-62803376="">
                    <h1
                      className="login-qr-title flex justify-center mb-24px"
                      data-v-62803376=""
                    >
                      {t("Chào mừng bạn đã trở lại Sising")}
                    </h1>
                    {/**/}
                  </div>
                  {/**/}
                  <div className="mt-24px" data-v-62803376="">
                    <div className="login-qr-form black" data-v-62803376="">
                      {/* /// Nhập Email hoặc SĐT */}
                      <div
                        className="login-form-group !mb-3"
                        data-v-62803376=""
                      >
                        <label data-v-62803376="">{t("Tên đăng nhập")}</label>
                        <div
                          data-v-4c55cf80=""
                          data-v-62803376=""
                          className="main-login-phone-mail"
                        >
                          <div data-v-4c55cf80="" className="phon-email-wrap">
                            <input
                              data-v-4c55cf80=""
                              type="text"
                              autoComplete="off"
                              value={form?.user_name}
                              onChange={(e) =>
                                setForm({ ...form, user_name: e.target.value })
                              }
                              name="dnPhone"
                              placeholder={t("Tên đăng nhập")}
                              data-testid="LoginAccountInput"
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>
                        </div>
                      </div>
                      {/* /// Nhập Password */}
                      <div className="login-form-group" data-v-62803376="">
                        <label data-v-62803376="">{t("Mật khẩu")}</label>
                        <div
                          data-v-4c55cf80=""
                          data-v-62803376=""
                          className="main-login-phone-mail"
                        >
                          <div data-v-4c55cf80="" className="phon-email-wrap">
                            <input
                              value={form?.password}
                              onChange={(e) =>
                                setForm({ ...form, password: e?.target?.value })
                              }
                              data-v-4c55cf80=""
                              type="text"
                              autoComplete="off"
                              name="dnPhone"
                              placeholder={t("Nhập Mật Khẩu")}
                              data-testid="LoginAccountInput"
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>
                        </div>
                      </div>
                      {/**/}
                      <div data-v-62803376=" " className="!mt-5">
                        <div className="iphone:mt-21px" data-v-62803376="">
                          <button
                            type="button"
                            className="bit-button w-full bit-button--chunky bit-button--medium is-round"
                            style={{ boxShadow: "0 4px 0 0 undefined" }}
                            data-v-62803376=""
                            onClick={handleLogin}
                          >
                            {/**/}
                            {/**/}
                            {/**/}
                            <span> {t("Đăng nhập")}</span>
                            {/**/}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="go-reg" data-v-62803376="">
                    <Link to="/forgot-password">
                      <span className="mr-2" data-v-62803376="">
                        {t("Quên mật khẩu?")}
                      </span>
                    </Link>
                  </div>
                  <div className="go-reg" data-v-62803376="">
                    <span className="mr-2" data-v-62803376="">
                      {t("Chưa có tài khoản?")}
                    </span>
                    <Link to="/register" data-v-62803376="">
                      {t("Đăng ký")}
                    </Link>
                  </div>
                </div>
                {/**/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
